import React, { useEffect, useState } from 'react';
import axios from 'axios'

export default function SiteSurvey({ siteSurvey, setSiteSurvey, isOpensite, setIsOpensite, selectpreoderid }) {
    const [shippingAddress, setShippingAddress ] = useState(null)
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSiteSurvey(prevData => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleCloseModal = () => {
        setIsOpensite(!isOpensite)
    }


    useEffect(()=>{
        axios({
            url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${selectpreoderid}`,
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
        })
            .then((res) => {
                const data = res.data;

                // Combine shipping address into a single field
                const shippingAddress = `${data.customer_shipping_address.address_line1}, ${data.customer_shipping_address.address_line2}, ${data.customer_shipping_address.city}, ${data.customer_shipping_address.state}, ${data.customer_shipping_address.country}, ${data.customer_shipping_address.pincode}`;
                
                setShippingAddress(shippingAddress)}).catch((err)=>{
                    console.log(err)
                })

    },[selectpreoderid])




    const uploadSitedetails = async (site_details) => {
        try {

            const response = await axios.post(`${process.env.REACT_APP_MYBACKEND_PI}/api/google-sheets/site-visit`, { site_details });
        } catch (error) {
            console.log('Error uploading data to Google Sheets:', error.response ? error.response.data : error.message);

        }
    };

    const updateSiteSurvey = async () => {
        // List of required fields with their labels
        const requiredFields = [
            { key: "DateofSiteSurvey", label: "Date of Site Survey" },
            { key: "TimeofSiteSurvey", label: "Time of Site Survey" }
        ];

        // Find missing fields
        const missingFields = requiredFields.filter(field => !siteSurvey[field.key]);

        if (missingFields.length > 0) {
            const missingFieldNames = missingFields.map(field => field.label).join(", ");
            alert(`⚠️ Please fill out the following required fields before submitting the request: ${missingFieldNames}. 😟`);
            return;
        }
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/updatesitevisit/${selectpreoderid}`,
                siteSurvey
            );
            alert("🎉✨ You have successfully raised a site visit request! ✨🎉");
            const getorder = await axios({
                url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${selectpreoderid}`,
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            })
                .then((res) => {
                    const data = res.data;

                    // Combine shipping address into a single field
                    const shippingAddress = `${data.customer_shipping_address.address_line1}, ${data.customer_shipping_address.address_line2}, ${data.customer_shipping_address.city}, ${data.customer_shipping_address.state}, ${data.customer_shipping_address.country}, ${data.customer_shipping_address.pincode}`;
                    console.log(shippingAddress,"cj")
                    setShippingAddress(shippingAddress)
                    // Format AC details into { SplitAc: { model: '10S', quantity: 2 }, ... }
                    const acDetails = data.AcDetails.reduce((acc, ac) => {
                        const acKey = `${ac.ac_type}Ac`; // e.g., 'SplitAc', 'CassetteAc'
                        if (!acc[acKey]) {
                            acc[acKey] = [];
                        }
                        acc[acKey].push({ model: ac.model, quantity: ac.quantity });
                        return acc;
                    }, {});

                    // Create site_details object
                    const site_details = {
                        customerName: data.customer.name,
                        customer_id: data.customer.customer_id,
                        customermobile: data.customer.mobile,
                        preOrdertimestamp: data.preOrdertimestamp,
                        contactPerson: data.customer_shipping_address.contactPerson,
                        contactNumber: data.customer_shipping_address.contactNumber,
                        DateofSiteSurvey: data.DateofSiteSurvey,
                        TimeofSiteSurvey: data.TimeofSiteSurvey,
                        siteSurveycomment: data.siteSurveycomment,
                        shippingAddress: shippingAddress
                    };

                    uploadSitedetails(site_details)


                })




            setIsOpensite(!isOpensite);
        } catch (error) {
            console.error("Error updating site survey:", error.response?.data || error.message);
            alert("⚠️ Oops! Failed to raise the site visit request. Please try again. 😟");
        }
    };
    function generateTimeSlots(selectedDate) {
        const slots = [];
        const startHour = 9; // Start time 9 AM
        const endHour = 18; // End time 6 PM (in 24-hour format)
        const now = new Date();
        const todayDate = now.toISOString().split('T')[0];

        // If no date is selected, return an empty array
        if (!selectedDate) return slots;

        const selectedDay = new Date(selectedDate);

        // Determine the start hour based on the selected date
        const initialHour =
            selectedDay.toISOString().split('T')[0] === todayDate
                ? Math.max(startHour, now.getHours() + 1) // Add +1 to skip the current hour
                : startHour;

        for (let hour = initialHour; hour < endHour; hour++) {
            const startTime = new Date();
            startTime.setHours(hour, 0, 0, 0);

            const endTime = new Date(startTime);
            endTime.setHours(hour + 1);

            slots.push(`${formatTime(startTime)} - ${formatTime(endTime)}`);
        }

        return slots;
    }

    function formatTime(date) {
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${period}`;
    }





    return (
        <>
            {isOpensite && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
                    onClick={handleCloseModal}
                >
                    <div
                        className="bg-white shadow-md rounded-xl border-2 p-4 max-w-lg w-full relative"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                    >
                        <button
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                            onClick={handleCloseModal}
                        >
                            ✖️
                        </button>

                        <h1 className="font-medium text-base mb-4">Site Survey Details</h1>

                        <div className="grid grid-cols-2 gap-4">

                            <div>
                                <label htmlFor="DateofSiteSurvey" className="block text-sm font-medium mb-1">
                                    Requested Site Visit Date
                                </label>
                                <input
                                    type="date"
                                    id="DateofSiteSurvey"
                                    name="DateofSiteSurvey"
                                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                                    value={siteSurvey.DateofSiteSurvey}

                                    onChange={handleInputChange}

                                    min={new Date().toISOString().split('T')[0]} // Restricts to today or future dates
                                />
                            </div>
                            <div>
                                <label htmlFor="TimeofSiteSurvey" className="block text-sm font-medium mb-1">
                                    Requested Site Visit Time
                                </label>
                                <select
                                    id="TimeofSiteSurvey"
                                    name="TimeofSiteSurvey"
                                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                                    value={siteSurvey.TimeofSiteSurvey || ""}
                                    onChange={handleInputChange}
                                    disabled={!siteSurvey.DateofSiteSurvey}
                                >
                                    <option value="" disabled>
                                        -- Select a time slot --
                                    </option>
                                    {generateTimeSlots(siteSurvey.DateofSiteSurvey).map((slot, index) => (
                                        <option key={index} value={slot}>
                                            {slot}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>
                        <div className="mt-4">
                            <label className="block text-sm font-medium mb-1">Site Address:</label>
                            <textarea
                                defaultValue={shippingAddress}
                                readOnly
                                name="siteAddress"
                                placeholder="Enter the site address here..."
                                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                            ></textarea>
                        </div>

                        {/* Comment Section */}
                        <div className="mt-4">
                            <label className="block text-sm font-medium mb-1">Write a Comment:</label>
                            <textarea
                                value={siteSurvey.siteSurveycomment || ""}
                                onChange={handleInputChange}
                                name="siteSurveycomment"
                                placeholder="Add your comments here..."
                                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                            ></textarea>
                        </div>

                        {/* Submit Button */}
                        <button
                            onClick={updateSiteSurvey}
                            className="w-full bg-primary text-white mt-4 rounded py-2 text-sm"
                        >
                            Request Site Visit
                        </button>
                    </div>
                </div>
            )}

        </>

    );
}
